import { createContext, useCallback, useContext, useState, type ReactNode } from "react";
import { BookSessionDialog } from "./BookSessionDialog";

interface BookingDialogContextValue {
  openBookingDialog: () => void;
  closeBookingDialog: () => void;
}

const BookingDialogContext = createContext<BookingDialogContextValue | null>(null);

export function BookingDialogProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const openBookingDialog = useCallback(() => setOpen(true), []);
  const closeBookingDialog = useCallback(() => setOpen(false), []);

  return (
    <BookingDialogContext.Provider value={{ openBookingDialog, closeBookingDialog }}>
      {children}
      <BookSessionDialog open={open} onOpenChange={setOpen} />
    </BookingDialogContext.Provider>
  );
}

export function useBookingDialog(): BookingDialogContextValue {
  const ctx = useContext(BookingDialogContext);
  if (!ctx) {
    // Soft fallback: log and return no-op so a missing provider never crashes the app.
    if (typeof console !== "undefined") {
      console.warn("useBookingDialog used outside BookingDialogProvider");
    }
    return { openBookingDialog: () => {}, closeBookingDialog: () => {} };
  }
  return ctx;
}
